import styled, { keyframes, css } from "styled-components";

const slideHint = keyframes`
  0% {
    width: 4rem;
  }
  50% {
    width: 8rem;
  }
  100% {
    width: 4rem;
  }
`;

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
`;

export const SlideButtonContainer = styled.div`
  background-color: #eaf5ff;
  border-color: #0c58b4;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  min-width: 200px;
  padding: 11px;
  position: relative;
  overflow: hidden;
  color: #4a4a4a;
  font-family: "Lato";
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  border-style: solid;
  border-width: 1px;

  * {
    box-sizing: border-box;
    pointer-events: none;
    user-select: none;
  }
`;

export const SlideOverlay = styled.div<{
  isSliding: boolean;
  animationRun: boolean;
}>`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  height: 100%;
  width: 2rem;
  background: #444;
  transition: width 0.2s ease-out;
  will-change: width;
  overflow: hidden;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0c58b4;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  animation: ${({ isSliding, animationRun }) =>
    isSliding || animationRun
      ? "none"
      : css`
          ${slideHint} 2s infinite
        `};
`;

export const SlideOverlayWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;

export const SlideCaretWrapper = styled.div`
  position: absolute;
  max-width: 45px;
  min-width: 0;
  right: 0;
  top: 50%;
  height: 100%;
  transform: translateY(-50%);
  background: #444;
  z-index: 2;
  display: flex;
  align-items: center;
  padding: 10px;
  justify-content: center;
  background-color: #0c58b4;
`;

export const SlideOverlayText = styled.div`
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  height: 100%;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
`;

export const ShimmerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #eaf5ff 0%, #99c2ff 50%, #eaf5ff 100%);
  background-size: 200% 100%;
  animation: ${shimmer} 2s infinite;
  z-index: 0;
`;

export const ShimmerText = styled.div`
  position: relative;
  color: #0c58b4;
  font-family: "Lato";
  font-weight: 700;
  font-size: 16px;
  z-index: 1;
`;
